import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "../components/TopBar/Header";
import Footer from "../components/Home/Footer";

const Layout = () => {
  return (
    <div className="max-w-[1920px] mx-auto overflow-hidden bg-white">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
